
import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { Engine } from '@/types';

interface EngineState {
  engines: Engine[];
  selectedEngineId: string | null;
  realTimeData: boolean;
  
  // Actions
  setEngines: (engines: Engine[]) => void;
  updateEngine: (id: string, data: Partial<Engine>) => void;
  selectEngine: (id: string | null) => void;
  toggleRealTimeData: () => void;
  
  // Computed
  selectedEngine: Engine | null;
  criticalEngines: Engine[];
}

export const useEngineStore = create<EngineState>()(
  devtools(
    subscribeWithSelector((set, get) => ({
      engines: [],
      selectedEngineId: null,
      realTimeData: false,

      setEngines: (engines) => set({ engines }),
      
      updateEngine: (id, data) => set((state) => ({
        engines: state.engines.map(engine => 
          engine.id === id ? { ...engine, ...data } : engine
        )
      })),
      
      selectEngine: (id) => set({ selectedEngineId: id }),
      
      toggleRealTimeData: () => set((state) => ({ 
        realTimeData: !state.realTimeData 
      })),

      get selectedEngine() {
        const { engines, selectedEngineId } = get();
        return engines.find(e => e.id === selectedEngineId) || null;
      },

      get criticalEngines() {
        return get().engines.filter(e => e.status === 'critical');
      },
    })),
    { name: 'engine-store' }
  )
);
